import { render, staticRenderFns } from "./external-rights-skeleton.vue?vue&type=template&id=2c85ea7f&scoped=true&lang=pug&"
import script from "./external-rights-skeleton.vue?vue&type=script&lang=js&"
export * from "./external-rights-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./external-rights-skeleton.vue?vue&type=style&index=0&id=2c85ea7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85ea7f",
  null
  
)

export default component.exports